import DataServiceSQL from "../DataService/DataServiceSQL";

//Function to convert fhir to gateway
const convert_fhir_gateway = (gateway_list) => {
  let ret = []
  gateway_list.entry.forEach(gateway => {
    if (gateway.type.text === "Gateway") {
      let new_gateway =
      {
        id_gw: gateway.identifier,
        gw_name: gateway.serialNumber,
        nickname: gateway.name.value,
        uptime: gateway.duration.time.value,
        fw_version_cur: gateway.version.value
      }
      if (gateway.status === "inactive") {
        new_gateway.online = "no"
      }
      else {
        new_gateway.online = "yes"
      }
      gateway.property.forEach(property => {
        switch (property.type.text) {
          case "FK_Tucky1":
            new_gateway.FK_Tucky1 = property.type.valueString
            break
          case "FK_Tucky2":
            new_gateway.FK_Tucky2 = property.type.valueString
            break
          case "FK_Tucky3":
            new_gateway.FK_Tucky3 = property.type.valueString
            break
          case "FK_Tucky4":
            new_gateway.FK_Tucky4 = property.type.valueString
            break
          case "FK_structure":
            new_gateway.FK_structure = property.type.valueString
            break
          case "action_status":
            new_gateway.action_status = property.type.valueString
            break
          case "device1_status":
            new_gateway.device1_status = property.type.valueString
            break
          case "device2_status":
            new_gateway.device2_status = property.type.valueString
            break
          case "device3_status":
            new_gateway.device3_status = property.type.valueString
            break
          case "device4_status":
            new_gateway.device4_status = property.type.valueString
            break
          case "error_log":
            new_gateway.error_log = property.type.valueString
            break
          case "freemem":
            new_gateway.freemem = property.type.valueInteger
            break
          case "lowest_mem":
            new_gateway.lowest_mem = property.type.valueInteger
            break
          case "wifi_rssi":
            new_gateway.wifi_rssi = property.type.valueInteger
            break
        }

      })
      ret.push(new_gateway)
    }
  })
  return ret
}

//Function to retrieve SQL gateway list
const get_gateway_list = async (struct_Id) => {
    return await DataServiceSQL.getAllDeviceReq_fhir(struct_Id)
      .then((response) => {
        if(response.data.length !==0 ){
          response.data = convert_fhir_gateway(response.data)
          return(response.data);
        }
        else{
          return("none");
        }
      })
      .catch((e) => {
        console.log(e);
      });
};

//Function to retrieve one SQL gateway by criteria
const get_gateway_by_criteria = async (criteria, value) => {
    return await DataServiceSQL.findDeviceReq_fhir(criteria, value)
      .then((response) => {
        if(response.data.entry.length !== 0 ){
          return(response.data);
        }
        else{
          return("none");
        }
      })
      .catch((e) => {
        console.log(e);
      });
};

//Const to import functions in other files
const GatewayFunctionsGetter = {
  convert_fhir_gateway,
  get_gateway_list,
  get_gateway_by_criteria  
};

export default GatewayFunctionsGetter;